module.exports = __webpack_public_path__ + "img/insurer-head-banner-mobile.bcd176b.webp";